"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyProtocolConfigurationResponseBodyStatus = exports.PrivacyProtocolConfigurationPatchRequestBodyStatus = exports.PrivacyProtocolConfigurationPutRequestBodyStatus = void 0;
exports.PrivacyProtocolConfigurationPutRequestBodyStatus = {
    disabled: 'disabled',
    enabled: 'enabled',
    none: 'none',
};
exports.PrivacyProtocolConfigurationPatchRequestBodyStatus = {
    disabled: 'disabled',
    enabled: 'enabled',
    none: 'none',
};
exports.PrivacyProtocolConfigurationResponseBodyStatus = {
    disabled: 'disabled',
    enabled: 'enabled',
    none: 'none',
};
